import _ from 'lodash';
import React from 'react';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as importCsvSettings from './importCsvSettings';



const ImportCsvModalComponent = ImportCsvModal.genComponent<importCsvSettings.NetSuiteEmployeesPropertyName>();

export interface IProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [importNetSuiteEmployees, importNetSuiteEmployeesTuple] = dataService.useImportNetSuiteEmployees();

  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      importNetSuiteEmployees(rows);
    },
    [
      importNetSuiteEmployees
    ]
  );

  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={importNetSuiteEmployeesTuple.loading}
      title="Import Employees"
      columnDescriptions={importCsvSettings.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={props.onAccept} />
  );
};
